import MasterStockList from "pages/report/master-stock/list"
import useMasterStockDetailReportRepositories from "repositories/master-stock-detail-report"

export default function List() {
  return (
    <MasterStockList
      title="Master Barang Detail"
      description="Ringkasan stok barang per product unit pada tanggal yang dipilih."
      labelHeader="KODE BARANG"
      endpoint="/reports/master-stock-detail"
      useRepository={useMasterStockDetailReportRepositories}
    />
  )
}
